<template>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1" style="background:#fafafa">
        <div class="d-flex flex-column flex-lg-row-fluid">
          <div class="p-5 m-5 loginWithoutOtp-box">
            <div href="#" class="mb-0 mb-lg-12 custom-logo d-block d-lg-none" style="text-align:center;">
              <img alt="Logo" src="assets/img/logo-dark.png" class="h-60px h-lg-75px" />
            </div>
            <div class="p-2">

              <h1 class="mb-5 text-center">إنشاء حساب جديد</h1>
              <hr>
              <h1 class="mb-5 text-center text-light"
                style="font-weight: 700;font-size: larger;color: #29ca50 !important;">
                Academia | أكاديميا
              </h1>
              <div class="loader-login-box text-center" v-if="loading">
                <h6 style="color: #10ce36">.. الرجاء الإنتظار</h6>
                <div class="spinner-border spinner-border-lg text-light" role="status"
                  style="color: #6dff89 !important; height: 120px; width: 120px">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <form @submit.prevent="submitForm" class="form-horizontal loginWithoutOtp" v-if="!loading">
                <div class="row" dir="rtl">
                  <div class="col-md-12">
                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="name">الاسم واللقب</label>
                      <input type="text" v-model="name" class="form-control" id="name" placeholder="أدخل الاسم" />
                      <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="email">البريد الإلكتروني (اختياري)</label>
                      <input type="email" v-model="email" class="form-control" id="email"
                        placeholder="أدخل البريد الإلكتروني" />
                      <small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="mobile">رقم الهاتف</label>
                      <input type="tel" v-model="mobile" class="form-control" id="mobile" maxlength="10" />
                      <small v-if="errors.mobile" class="text-danger">{{ errors.mobile }}</small>
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="password">كلمة المرور</label>
                      <input type="password" v-model="password" class="form-control" id="password"
                        placeholder="..........." />
                      <small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
                    </div>

                    <!-- Select for Levels -->
                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="level-select">المستوى التعليمي <i v-if="infoDataLoader == true"
                          class="fa fa-spinner fa-spin" style="font-size:24px"></i></label>
                      <select v-model="selectedLevel" class="form-control" id="level-select" @change="onLevelChange">
                        <option value="" disabled>اختر المستوى</option>
                        <option v-for="level in levels" :key="level.id" :value="level.id">{{ level.name }}</option>
                      </select>
                      <small v-if="errors.selectedLevel" class="text-danger">{{ errors.selectedLevel }}</small>
                    </div>

                    <!-- Select for Educations -->
                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="education-select"> التخصص
                      </label>
                      <select v-model="selectedEducation" class="form-control" id="education-select"
                        :disabled="!selectedLevel">
                        <!-- عرض null فقط إذا كانت القائمة فارغة -->
                        <option v-if="!filteredEducations.length" :value="null"> ... </option>
                        <option v-else value="" disabled>التخصص</option>
                        <option v-for="education in filteredEducations" :key="education.id" :value="education.id">
                          {{ education.name }}
                        </option>
                      </select>
                      <small v-if="errors.selectedEducation" class="text-danger">{{ errors.selectedEducation }}</small>
                    </div>


                    <!-- Select for Years -->
                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="year-select">اختر السنة</label>
                      <select v-model="selectedYear" class="form-control" id="year-select">
                        <option value="" disabled>اختر السنة</option>
                        <option v-for="year in years" :key="year.id" :value="year.id">{{ year.name }}</option>
                      </select>
                    </div>
                    <div class="fv-row mb-8 fv-plugins-icon-container">
                      <label class="form-check form-check-inline">
                        <input v-model="acceptPrivacy" class="form-check-input" type="checkbox" name="toc" value="1">
                        <span class="form-check-label fw-semibold text-gray-700 fs-base ms-1">بالتسجيل أوافق على
                          <a href="#" class="ms-1 link-success" data-bs-toggle="modal"
                            data-bs-target="#privacyModal">الشروط والأحكام وسياسة الخصوصية</a></span>
                      </label>
                      <div class="fv-plugins-message-container invalid-feedback"></div>
                      <small v-if="errors.acceptPrivacy" class="text-danger">{{ errors.acceptPrivacy }}</small>

                    </div>
                    <div class="d-grid gap-2">
                      <div class="mt-4 login">
                        <button class="p-3 btn btn-success btn-block waves-effect waves-light"
                          style="height: 55px;background: #31d15f; font-weight:700;font-size: 19px; width: 100%"
                          type="submit">
                          إنشاء حساب <i class="fa-solid fa-user-plus"></i>
                        </button>
                      </div>
                    </div>
                    <hr>
                    <div class="text-gray-500 text-center fw-semibold fs-6">لدي حساب بالفعل
                      <a href="login" class="link-success fw-semibold" style="font-weight: 700 !important;">تسجيل
                        دخول</a>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        style="background: #fff">
        <div class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
          <a href="#" class="mb-0 mb-lg-12 d-none d-lg-block">
            <img alt="Logo" src="assets/img/logo-dark.png" class="h-60px h-lg-75px" />
          </a>
          <img class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-350px mb-10 mb-lg-20" src="assets/img/register.gif"
            alt="" />
          <h1 class="d-none d-lg-block text-success fs-2qx fw-bolder text-center mb-7">أكاديميا - تعلم بلا حدود</h1>
          <div class="d-none d-lg-block text-success fs-base text-center">
            تطبيق أكاديميا يوفر تعليم عالي الجودة لطلاب المدارس الإعدادية
            والثانوية والجامعة. بفضل ميزاته المميزة ونهجه التكنولوجي، يمكن
            للطلاب الوصول إلى محتوى تدريب متميز في أي وقت ومن أي مكان.
          </div>
        </div>
      </div>
    </div>
  </div>
  <!---------------Download App Modal----------------------------------------->
  <div dir="rtl" class="modal fade forgetpassword-modal" id="privacyModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            سياسة الأحكام والخصوصية
          </h5>
        </div>
        <div class="modal-body">
          <div href="#" class="mb-0 mb-lg-12 custom-logo" style="text-align:center;">
            <img alt="Logo" src="assets/img/logo-dark.png" class="h-60px h-lg-75px" />
          </div>
          <h4 class="mb-2 text-center support-text">
            سياسة منصّة أكاديميا وأهمّ ما تقدّمه لكم:
          </h4>

          <ol class="mb-4">
            <li>
              <strong>مدة بقاء الكورس:</strong>
              تبقى الكورسات متاحة حتى موعد امتحان المادة في الفصل الدراسي، مع إمكانية تمديد الفترة في حال حدوث أي تأجيل.
            </li>
            <li>
              <strong>استرجاع الاشتراك في حال إسقاط المادة:</strong>
              يمكن استرجاع الاشتراك كاملاً في حال إسقاط المادة قبل الامتحان، بشرط تقديم صورة من حساب الطالب تثبت ذلك.
            </li>
            <li>
              <strong>عدد الأجهزة المسموح بها:</strong>
              يمكن للطالب فتح حسابه على هاتفين شخصيين أو هاتف وتابلت، بالإضافة إلى الدراسة من اللابتوب. لا يمكن المشاهدة
              من جهازين في نفس الوقت، ولا يُسمح بمشاركة اشتراك بين طالبين.
            </li>
            <li>
              <strong>مشكلات في تشغيل التطبيق:</strong>
              في حال واجه الطلاب صعوبات في تشغيل التطبيق أو مشاهدة الفيديوهات، نوفر لهم خيار المشاهدة عبر موقع بديل بكل
              سهولة، وذلك بالتواصل معنا.
            </li>
            <li>
              <strong>التعامل مع الظروف الاستثنائية:</strong>
              نتعامل بشكل استثنائي مع الطلاب الذين يواجهون ظروفاً استثنائية، ونبحث دائماً عن الحلول الممكنة لهم.
            </li>
            <li>
              <strong>توثيق الحساب:</strong>
              يتطلب توثيق الحساب إدخال الاسم الثلاثي (من البطاقة الشخصية أو جواز السفر) مع إمكانية إخفاء الصورة. التوثيق
              يتم مرة واحدة فقط، والهدف منه حماية الحساب من الانتحال وحماية الخصوصية.
            </li>
            <li>
              <strong>التواصل معنا:</strong>
              نرحب بتواصل الطلاب الذين يواجهون مشكلات أو لديهم استفسارات عبر بريد صفحتنا على الفيسبوك أو رقم التلغرام <a
                href="tel:0913103064">0913103064</a>.
            </li>
          </ol>

          <p class="text-center">
            كل الاحترام والتقدير للجميع.
          </p>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hashV2 } from "@/utils/api";
import QRCode from "qrcodejs2";
import Swal from "sweetalert2";

import '../assets/blockui';
import { apiUrl, deviceId, baseUrl, getBrowserName } from "@/utils/api";
var iti;
var phone;

export default {
  data() {
    return {
      name: '',
      email: '',
      mobile: '',
      password: '',
      acceptPrivacy: '',
      selectedLevel: null,
      selectedEducation: null,
      selectedYear: null,
      loading: false,
      infoDataLoader: true,
      errors: {},
    };
  },
  computed: {
    filteredEducations() {
      if (this.selectedLevel) {
        const level = this.levels.find(l => l.id === this.selectedLevel);
        return level ? level.educations : [];
      }
      return [];
    },
  },
  mounted() {
    phone = document.querySelector("#mobile");
    $(document).ready(function () {

      iti = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly", // Set Libya as the default country
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
    // Fetch the data from the API
    this.fetchData();
  },
  methods: {
    fetchData() {
      $.ajax({
        url: apiUrl + "/get-info-data", // Replace with your actual API URL
        method: "GET",
        dataType: "json",
        success: (response) => {
          this.infoDataLoader = false;
          this.levels = response.levels;
          this.years = response.years;
        },
        error: (error) => {
          console.error("Error fetching data:", error);
        },
      });
    },
    onLevelChange() {
      this.selectedEducation = null; // Reset education when level changes
    },
    validateForm() {
      const errors = {};

      if (!this.name) errors.name = "الاسم مطلوب";
      if (this.email && !/\S+@\S+\.\S+/.test(this.email)) errors.email = "البريد الإلكتروني غير صحيح";
      if (!this.mobile || !/^(09\d{8}|\d{9})$/.test(this.mobile)) {
        errors.mobile = "رقم الهاتف غير صحيح";
      }
      if (!this.password) errors.password = "كلمة المرور مطلوبة";
      if (!this.selectedLevel) errors.selectedLevel = "المستوى مطلوب";

      // شرط للتعليم: السماح بأن يكون null فقط في حال عدم وجود تخصصات متاحة
      if (!this.selectedEducation && this.filteredEducations.length > 0) {
        errors.selectedEducation = "التعليم مطلوب";
      }

      if (!this.selectedYear) errors.selectedYear = "السنة مطلوبة";
      if (!this.acceptPrivacy) errors.acceptPrivacy = "يجب الموافقة على سياسة الخصوصية";

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },

    submitForm() {
      if (!this.validateForm()) return;

      const webInfo = {
        id: "device_id", // قم بتحديث هذا الحقل حسب الحاجة
        brand: "device_brand", // قم بتحديث هذا الحقل حسب الحاجة
      };

      const now = new Date();

      let data = {
        name: this.name,
        password: this.password,
        mobile: iti.getNumber(),
        device_name: webInfo.brand,
        level_id: this.selectedLevel,
        location: "0", // قم بتحديث هذا الحقل حسب الحاجة
        education_id: this.selectedEducation,
        year_id: this.selectedYear,
        guest: "0", // قم بتحديث هذا الحقل حسب الحاجة
      };

      if (this.email) {
        data.email = this.email;
      }

      // عرض BlockUI
      $('.loginWithoutOtp-box').block({
        message: '<span style="margin:0px;padding:8px;font-size:18px;color:#29ca50;">الرجاء الإنتظار..</span>', // لون النص أخضر
        css: {
          backgroundColor: 'rgba(255, 255, 255, 0.8)', // خلفية بيضاء شفافة
          color: '#000', // لون النص الافتراضي
          border: '0px',
          padding: '15px',
          '-webkit-border-radius': '10px',
          '-moz-border-radius': '10px',
          opacity: 1
        },
        overlayCSS: {
          backgroundColor: 'rgb(204 204 204 / 80%)', // تغيير لون الخلفية overlay إلى أبيض شفاف
          opacity: 0.8, // يمكنك ضبط الشفافية هنا
          cursor: 'wait'
        }
      });
      $.ajax({
        url: apiUrl + "/register", // استبدل هذا بالمسار الصحيح
        method: "POST",
        data: hashV2(data),
        success: (response) => {
          this.loading = false;
          localStorage.setItem("access_token", response.access_token);
          localStorage.setItem("expires_in", response.expires_in);

          // إخفاء BlockUI

          // عرض SweetAlert ترحيبي
          Swal.fire({
            title: 'مرحبًا!',
            text: 'تم إنشاء الحساب بنجاح!',
            icon: 'success',
            confirmButtonText: 'موافق'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/home"; // الانتقال إلى صفحة الرئيسية
            }
          });
        },
        error: (error) => {
          this.loading = false;

          let errorMessage = 'حدث خطأ غير متوقع.';

          // التحقق من وجود الرسالة في responseJSON
          if (error.responseJSON && error.responseJSON.message) {
            errorMessage = error.responseJSON.message;  // الرسالة من responseJSON
          } else if (error.responseText) {
            try {
              let errorData = JSON.parse(error.responseText);  // محاولة تحويل responseText إلى JSON
              errorMessage = errorData.message || errorMessage;  // استخدام الرسالة إن وجدت
            } catch (e) {
              console.error("Error parsing responseText:", e);
            }
          }

          Swal.fire({
            title: 'خطأ في عملية التسجيل',
            text: errorMessage,  // عرض رسالة الخطأ
            icon: 'error',       // أيقونة خطأ
            confirmButtonText: 'موافق'
          });

          $('.loginWithoutOtp-box').unblock();
          console.error("Error creating account:", error);
        },


      });
    },
  },
};
</script>
<style>
label {
  font-weight: 700;
}

.form-control {
  height: 45px;
  font-size: 15px;
  width: 100%;
}
</style>